import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal-visualize-image',
  templateUrl: './modal-visualize-image.component.html',
  styleUrls: ['./modal-visualize-image.component.scss']
})
export class ModalVisualizeImageComponent implements OnInit {

  @Input() contentHTML: HTMLImageElement;
  @Output() closeModal  =  new EventEmitter<boolean>();
  
  constructor() { }

  ngOnInit() {
  }

  close() {
    this.closeModal.emit(false);
  }


}
